var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bulk/close-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "close-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.4,
    d: "M14.0002 25.6668C20.4435 25.6668 25.6668 20.4435 25.6668 14.0002C25.6668 7.55684 20.4435 2.3335 14.0002 2.3335C7.55684 2.3335 2.3335 7.55684 2.3335 14.0002C2.3335 20.4435 7.55684 25.6668 14.0002 25.6668Z",
    fill: "#C72929"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.2366 13.9999L17.9199 11.3166C18.2583 10.9783 18.2583 10.4183 17.9199 10.0799C17.5816 9.74159 17.0216 9.74159 16.6833 10.0799L13.9999 12.7633L11.3166 10.0799C10.9783 9.74159 10.4183 9.74159 10.0799 10.0799C9.74159 10.4183 9.74159 10.9783 10.0799 11.3166L12.7633 13.9999L10.0799 16.6833C9.74159 17.0216 9.74159 17.5816 10.0799 17.9199C10.2549 18.0949 10.4766 18.1766 10.6983 18.1766C10.9199 18.1766 11.1416 18.0949 11.3166 17.9199L13.9999 15.2366L16.6833 17.9199C16.8583 18.0949 17.0799 18.1766 17.3016 18.1766C17.5233 18.1766 17.7449 18.0949 17.9199 17.9199C18.2583 17.5816 18.2583 17.0216 17.9199 16.6833L15.2366 13.9999Z",
    fill: "#C72929"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/close-circle.3246201b9387667e368dd3f4086bd916.svg";
export { ForwardRef as ReactComponent };